// @ts-nocheck
import {
  DeleteOutlined,
  FormOutlined,
  MoreOutlined,
  PrinterOutlined,
} from '@ant-design/icons'
import {
  Col,
  DatePicker,
  Dropdown,
  List,
  Menu,
  Modal,
  Progress,
  Row,
  Tag,
  Tooltip,
  Typography,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import { EmptyText, TitleContentBox } from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import FeedbackSign from '../../../components/PopupSign/FeedbackSign'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  VIEWLOG_DATE,
} from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { FeedbackProcedureRequest } from '../../../requests/FeedbackProcedureRequest'
import utils from '../../../utils'
import {
  DocumentInfoList,
  UserListWrapper,
} from '../InternalDocumentIncomingDocDetailPage/InternalDocumentIncomingDocDetailPageStyled'
import ExportPdf from './ExportPdf/ExportPdf'
import ExportDocx from './ExportWord/ExportWord'
import {
  BlockLeft,
  BlockRight,
  ContentWrapper,
  HeadingButtonWrapper,
  ViewDetailContent,
} from './FeedbackBoardPageStyled'
import FeedbackBoardUpdate from './FeedbackBoardUpdate '
import FeedbackVotingPopup from './FeedbackVote/FeedbackVotingPopup'
import PopoverWatchTime from './components/PopoverWatchTime'
import { systemName } from '../../../config'


const FeedbackBoardDetail = props => {
  const {
    selectPeopleStore,
    fileStore,
    userGroupStore,
    signedDocumentStore,
    authenticationStore,
    loadingAnimationStore,
    FeedbackProcedureStore,
    FeedbackCommentStore,
    departmentStore,
    selectUserStore,
    userStore,
    match,
    history,
    location,
  } = props
  const { departmentWithUserListV2 } = selectPeopleStore
  const { userList } = userStore
  const { feedbackId } = match.params
  const { currentUser } = authenticationStore
  const { feedbackDetailData } = FeedbackProcedureStore
  const { documentAttachment } = fileStore
  const { allDataGroupList } = userGroupStore
  const { feedbackCommentDataDetailV2 } = FeedbackCommentStore
  const [isVisiblePopupBieuQuyet, setIsVisiblePopupBieuQuyet] = useState(false)
  const [asigneeData, setAsigneeData] = useState([])
  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [exportDocx, setExportDocx] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(true)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [indexLmao, setIndexLmao] = useState(null)
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)

  const fetchDetailComment = async id => {
    try {
      await FeedbackCommentStore.getFeedbackCommentById(id)
    } catch (error) {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getGroupList()
        await selectPeopleStore.getDepartmentWithUsersV2()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [])

  feedbackDetailData?.assignees?.forEach(assignee => {
    const matchingData = departmentWithUserListV2?.find(
      item => item.code === assignee.assignee_code
    )
    if (matchingData) {
      assignee.length = matchingData.length
    }
  })
  const departmentMap = useMemo(() => {
    const map = new Map()
    departmentWithUserListV2?.forEach(dept => {
      map.set(dept.code, dept.name)
      dept.users.forEach(user => {
        map.set(user.user_code, user.name_uppercase)
      })
    })
    return map
  }, [departmentWithUserListV2])

  useEffect(() => {
    if (!feedbackDetailData?.assignees || !departmentMap.size) return

    const assigneesProcessed = feedbackDetailData.assignees.map(assignee => {
      assignee.name_uppercase =
        departmentMap.get(assignee.assignee_code) || assignee.name_uppercase
      return assignee
    })

    setAsigneeData(assigneesProcessed)
    loadingAnimationStore.showSpinner(false)
  }, [departmentMap, feedbackDetailData?.assignees])
  const handleOpenPopup = () => {
    setIsVisiblePopupBieuQuyet(true)
  }

  const handleClosePopup = () => {
    setIsVisiblePopupBieuQuyet(false)
  }

  const handleOpenEditModal = () => {
    console.log('Opening edit modal')
    setIsEditModalVisible(true)
  }

  const handleCloseEditModal = () => {
    console.log('Closing edit modal')
    setIsEditModalVisible(false)
  }

  const handleExportDocx = shouldExport => {
    if (shouldExport) {
      setExportDocx(true)
    }
  }

  useEffect(() => {
    if (exportDocx) {
      setExportDocx(false)
    }
  }, [exportDocx])

  const fetchFeedbackDetailData = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await FeedbackProcedureStore.getElectronicDocumentById(feedbackId)
    } catch (err) {
      console.log(err)
      // message.error('Bạn không có quyền truy cập phiếu ý kiến này')
      // history.push('/feedback-hdqt')
    }

    loadingAnimationStore.showSpinner(false)
  }

  useEffect(() => {
    fetchFeedbackDetailData()
  }, [feedbackId])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      loadingAnimationStore.showSpinner(true)
      userStore.setFilter('userListStatus', true)
      userStore.setFilter(
        'companyCode',
        authenticationStore.currentCompanyCode()
      )
      userStore.getUserListV2().finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
    }
    return () => {
      userStore.clearStore()
    }
  }, [authenticationStore.currentUser])

  const groupType = location.pathname.includes('feedback-hdqt')
    ? 'nhiem_vu'
    : undefined

  useEffect(() => {
    ;(async () => {
      if (authenticationStore.currentUser) {
        try {
          loadingAnimationStore.showSpinner(true)
          const responseGroupList = await userGroupStore.getAllGroupList()
        } catch (err) {
          console.log(err)
          message.error('Đã có lỗi xảy ra!')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      }
    })()
  }, [authenticationStore.currentUser])

  function getNameUppercaseByUsername(username) {
    const user = userList?.find(user => user.username === username)
    if (user) {
      return user.name_uppercase
    } else {
      return `Admin`
    }
  }

  const [allFileNames, setAllFileNames] = useState([])
  useEffect(() => {
    const fetchFileNames = async () => {
      if (!feedbackDetailData?.fileIdAttachment) return
      const allFileNamesResponse = await Promise.all(
        feedbackDetailData.fileIdAttachment.map(fileId =>
          FeedbackProcedureStore.getElectronicDocumentFileName(
            fileId.fileId.replace(/[\[\]]/g, '')
          )
        )
      )
      setAllFileNames(allFileNamesResponse.map(response => response.data))
    }
    fetchFileNames()
  }, [feedbackDetailData?.fileIdAttachment])

  const idIncludes = feedbackDetailData?.feedbackComments?.map(item => item.id)
  const feedbackComments = feedbackCommentDataDetailV2?.feedbackCommentDetails

  const latestFeedbacks =
    feedbackCommentDataDetailV2?.feedbackCommentDetails &&
    Array.from(
      feedbackCommentDataDetailV2.feedbackCommentDetails
        .reduce((map, comment) => {
          if (comment.fileId) {
            const existing = map.get(comment.feedbackUsername)
            if (
              !existing ||
              new Date(comment.createdAt) > new Date(existing.createdAt)
            ) {
              map.set(comment.feedbackUsername, comment)
            }
          }
          return map
        }, new Map())
        .values()
    )

  const results = feedbackDetailData?.feedbackComments?.map(comment => {
    const latestVotes = {}
    comment.feedbackCommentDetails.forEach(detail => {
      const { feedbackUsername, voteType, createdAt } = detail
      if (voteType) {
        if (
          !latestVotes[feedbackUsername] ||
          new Date(latestVotes[feedbackUsername].createdAt) <
            new Date(createdAt)
        ) {
          latestVotes[feedbackUsername] = {
            ...detail,
            content: comment.content,
          }
        }
      }
    })
    return Object.values(latestVotes)
  })
  const voteCounts = {
    AGREE: 0,
    DISAGREE: 0,
    OTHER: 0,
  }

  let totalCount = 0

  results?.forEach(feedbackGroup => {
    feedbackGroup.forEach(feedback => {
      if (feedback.voteType in voteCounts) {
        voteCounts[feedback.voteType]++
      }
      totalCount++
    })
  })

  const countAllUser = latestFeedbacks?.length || 0
  const countAgree =
    latestFeedbacks?.filter(comment => comment.voteType === 'AGREE')?.length ||
    0

  const countDisAgree =
    latestFeedbacks?.filter(comment => comment.voteType === 'DISAGREE')
      ?.length || 0

  const countOther =
    latestFeedbacks?.filter(comment => comment.voteType === 'OTHER')?.length ||
    0
  let agreeCount = 0
  let disagreeCount = 0
  let otherCount = 0
  latestFeedbacks?.forEach(comment => {
    comment?.feedbackCommentDetails?.forEach(detail => {
      if (detail.voteType === 'AGREE') {
        agreeCount++
      } else if (detail.voteType === 'DISAGREE') {
        disagreeCount++
      } else if (detail.voteType === 'OTHER') {
        otherCount++
      }
    })
  })
  let totalVote = agreeCount + disagreeCount + otherCount

  const picAssignees =
    feedbackDetailData?.assignees?.filter(
      assignee => assignee.permission === 'PIC'
    ) || []

  const uniqueAssignees = []
  const seenCodes = new Set()

  for (const assignee of picAssignees) {
    if (!seenCodes.has(assignee.assignee_code)) {
      uniqueAssignees.push(assignee)
      seenCodes.add(assignee.assignee_code)
    } else {
      const existingIndex = uniqueAssignees.findIndex(
        a => a.assignee_code === assignee.assignee_code
      )
      if (
        existingIndex !== -1 &&
        uniqueAssignees[existingIndex].assignee_type === 'USER' &&
        assignee.assignee_type === 'DPT'
      ) {
        uniqueAssignees[existingIndex] = assignee
      }
    }
  }

  const totalPeopleCount = uniqueAssignees.reduce(
    (sum, assignee) => sum + (assignee.length || 0),
    0
  )

  const countedUsers = new Set()

  departmentWithUserListV2.forEach(department => {
    department.users.forEach(user => {
      countedUsers.add(user.user_code)
    })
  })

  let totalPeopleCountv2 = 0

  // Calculate total count from individuals
  picAssignees.forEach(individual => {
    if (individual.assignee_type === 'USER') {
      // Check if individual is already counted
      if (!countedUsers.has(individual.assignee_code)) {
        totalPeopleCountv2 += 1
      }
    } else if (individual.assignee_type === 'DPT') {
      // For departments, add their length only if not already counted
      if (!countedUsers.has(individual.assignee_code)) {
        totalPeopleCountv2 += individual.length
        countedUsers.add(individual.assignee_code)
      }
    }
  })

  const handleDelete = () => {
    Modal.confirm({
      title: 'Bạn có muốn xóa ý kiến này không?',
      okText: 'Đồng ý',
      okType: 'danger',
      cancelText: 'Hủy',
      onOk: async () => {
        try {
          await FeedbackProcedureRequest.deleteFeedbackProcedure(
            feedbackDetailData.id
          )
          message.success('Đã xóa ý kiến thành công!')
          history.push('/feedback-hdqt')
        } catch (error) {
          // console.log('Error when delete feedback procedure', error)
        }
      },
      onCancel() {
        console.log('Cancelled deletion')
      },
    })
  }

  feedbackDetailData?.assignees?.forEach(el => {
    const user =
      userList && userList?.find(user => user.username === el.assignee_code)
    if (user) {
      el.name_uppercase = user.name_uppercase
    }
  })

  const handlerAssignList = feedbackDetailData?.assignees
    ?.filter(el => el.permission === 'PIC')
    ?.reduce((unique, item) => {
      const isDuplicate = unique.some(
        el => el.assignee_code === item.assignee_code
      )
      return isDuplicate ? unique : [...unique, item]
    }, [])

  const combinerAssignList = feedbackDetailData?.assignees
    ?.filter(el => el.permission === 'VIEW')
    ?.reduce((unique, item) => {
      const isDuplicate = unique.some(
        el => el.assignee_code === item.assignee_code
      )
      return isDuplicate ? unique : [...unique, item]
    }, [])

  const updatedData1 = combinerAssignList?.map(item1 => {
    let name_uppercase = null
    let username = null
    let image = null

    if (item1.assignee_type === 'USER') {
      // Trường hợp assignee_type là "USER"
      const matchedUser = allDataGroupList
        ?.flatMap(group => group.groupUsers || [])
        ?.find(userItem => userItem.user.user_name === item1.assignee_code)
      if (matchedUser) {
        name_uppercase = matchedUser.user.name_lowercase?.toUpperCase() || null
        username = matchedUser.user.user_name || null
        image = matchedUser.user.image || null
      }
    } else if (item1.assignee_type === 'GRP') {
      // Trường hợp assignee_type là "GRP"
      const matchedGroup = allDataGroupList?.find(
        group => group.id.toString() === item1.assignee_code
      )

      if (matchedGroup) {
        name_uppercase = matchedGroup.name?.toUpperCase() || null
        image = matchedGroup.image || null
      }
    }

    return {
      ...item1,
      name_uppercase,
      username,
      image,
    }
  })

  const isVotingUser = feedbackDetailData?.assignees?.filter(
    el => el.permission === 'PIC'
  )
  const isUnVotingUser = feedbackDetailData?.assignees?.filter(
    el => el.permission === 'VIEW'
  )
  const userFromDepartment = departmentWithUserListV2
    .filter(group =>
      isVotingUser?.some(assignee => assignee.assignee_code === group.code)
    )
    .flatMap(group => group.users)

  const userFromUserName = departmentWithUserListV2
    .map(group => {
      const matchingUsers = group.users.filter(user =>
        isVotingUser?.some(
          assignee => assignee.assignee_code === user.user_name
        )
      )
      if (matchingUsers.length > 0) {
        return matchingUsers
      }
      return null
    })
    .filter(Boolean)
    .flat()

  const uniqueUsers = [...userFromDepartment, ...userFromUserName].reduce(
    (acc, user) => {
      if (
        !acc.some(existingUser => existingUser.user_name === user.user_name)
      ) {
        acc.push(user)
      }
      return acc
    },
    []
  )

  const userFromDepartmentv2 = departmentWithUserListV2
    .filter(group =>
      isUnVotingUser?.some(assignee => assignee.assignee_code === group.code)
    )
    .flatMap(group => group.users)

  const userFromUserNamev2 = departmentWithUserListV2
    .map(group => {
      const matchingUsers = group.users.filter(user =>
        isUnVotingUser?.some(
          assignee => assignee.assignee_code === user.user_name
        )
      )
      if (matchingUsers.length > 0) {
        return matchingUsers
      }
      return null
    })
    .filter(Boolean)
    .flat()

  const uniqueUsersv2 = [...userFromDepartmentv2, ...userFromUserNamev2].reduce(
    (acc, user) => {
      if (
        !acc.some(existingUser => existingUser.user_name === user.user_name)
      ) {
        acc.push(user)
      }
      return acc
    },
    []
  )

  const userNameHaveVoting = uniqueUsersv2.map(user => user.user_name)
  const userNameHaventVoting = uniqueUsers.map(user => user.user_name)

  const menuHandleDocument = (
    <Menu>
      <AccessControlAction aclActionType={ACL_ACTION_TYPE.update__HDQT}>
        <Menu.Item
          icon={<FormOutlined style={{ color: blue }} />}
          onClick={handleOpenEditModal}>
          <span style={{ color: blue }}>Chỉnh sửa</span>
        </Menu.Item>
      </AccessControlAction>

      <AccessControlAction aclActionType={ACL_ACTION_TYPE.export__HDQT}>
        <Menu.Item
          icon={<PrinterOutlined style={{ color: blue }} />}
          onClick={() => {
            handleExportDocx(true)
          }}>
          <span style={{ color: blue }}>In</span>
        </Menu.Item>
      </AccessControlAction>

      <AccessControlAction aclActionType={ACL_ACTION_TYPE.delete__HDQT}>
        <Menu.Item danger onClick={handleDelete} icon={<DeleteOutlined />}>
          Xóa phiếu
        </Menu.Item>
      </AccessControlAction>
    </Menu>
  )

  const getVoteCountsForFeedback = feedbackId => {
    const selectedFeedback = feedbackDetailData?.feedbackComments?.find(
      comment => comment.id === feedbackId
    )

    const voteCounts = { AGREE: 0, DISAGREE: 0, OTHER: 0 }
    let totalCount = 0

    if (selectedFeedback) {
      const latestVotes = selectedFeedback.feedbackCommentDetails.reduce(
        (acc, detail) => {
          const { feedbackUsername, voteType, createdAt } = detail
          if (voteType) {
            if (
              !acc[feedbackUsername] ||
              new Date(acc[feedbackUsername].createdAt) < new Date(createdAt)
            ) {
              acc[feedbackUsername] = detail
            }
          }
          return acc
        },
        {}
      )

      Object.values(latestVotes).forEach(detail => {
        if (detail.voteType in voteCounts) {
          voteCounts[detail.voteType]++
          totalCount++
        }
      })
    }

    return { voteCounts, totalCount }
  }

  const getDataForFeedback = feedbackId => {
    const { voteCounts } = getVoteCountsForFeedback(feedbackId)
    if (selectedIndex && feedbackId === selectedIndex) {
      return [
        {
          label: 'Tỷ lệ đồng ý',
          countValue:
            voteCounts.AGREE === 0
              ? `0/${totalPeopleCountv2}`
              : `${voteCounts.AGREE}/${totalPeopleCountv2}`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.AGREE / totalPeopleCountv2) * 100,
          color: 'blue',
        },
        {
          label: 'Không đồng ý',
          countValue:
            voteCounts.DISAGREE === 0
              ? `0/${totalPeopleCountv2}`
              : `${voteCounts.DISAGREE}/${totalPeopleCountv2}`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.DISAGREE / totalPeopleCountv2) * 100,
          color: 'red',
        },
        {
          label: 'Không có ý kiến/ Ý kiến khác',
          countValue:
            voteCounts.OTHER === 0
              ? `0/${totalPeopleCountv2}`
              : `${voteCounts.OTHER}/${totalPeopleCountv2}`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.OTHER / totalPeopleCountv2) * 100,
          color: 'green',
        },
      ]
    } else {
      // Hiển thị % dựa trên totalPeopleCountv2 khi không chọn
      return [
        {
          label: 'Tỷ lệ đồng ý',
          value:
            totalPeopleCountv2 === 0
              ? '0%'
              : `${((voteCounts.AGREE / totalPeopleCountv2) * 100).toFixed(
                  2
                )}%`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.AGREE / totalPeopleCountv2) * 100,
          color: 'blue',
        },
        {
          label: 'Không đồng ý',
          value:
            totalPeopleCountv2 === 0
              ? '0%'
              : `${((voteCounts.DISAGREE / totalPeopleCountv2) * 100).toFixed(
                  2
                )}%`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.DISAGREE / totalPeopleCountv2) * 100,
          color: 'red',
        },
        {
          label: 'Không có ý kiến/ Ý kiến khác',
          value:
            totalPeopleCountv2 === 0
              ? '0%'
              : `${((voteCounts.OTHER / totalPeopleCountv2) * 100).toFixed(
                  2
                )}%`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.OTHER / totalPeopleCountv2) * 100,
          color: 'green',
        },
      ]
    }
  }

  const data = [
    {
      label: 'Tỷ lệ đồng ý',
      value: `${Number(countAgree)}/${Number(totalPeopleCountv2)}`,
      percent: (Number(countAgree) / Number(totalPeopleCountv2)) * 100,
      color: 'blue',
    },
    {
      label: 'Không đồng ý',
      value: `${Number(countDisAgree)}/${Number(totalPeopleCountv2)}`,
      percent: (Number(countDisAgree) / Number(totalPeopleCountv2)) * 100,
      color: 'red',
    },
    {
      label: 'Không có ý kiến/ Ý kiến khác',
      value: `${Number(countOther)}/${Number(totalPeopleCountv2)}`,
      percent: (Number(countOther) / Number(totalPeopleCountv2)) * 100,
      color: 'green',
    },
  ]

  const data2 = [
    {
      label: 'Tỷ lệ đồng ý',
      value:
        totalPeopleCountv2 === 0
          ? '0%'
          : `${((voteCounts.AGREE / totalPeopleCountv2) * 100).toFixed(2)}%`,
      percent:
        totalPeopleCountv2 === 0
          ? 0
          : (voteCounts.AGREE / totalPeopleCountv2) * 100,
      color: 'blue',
    },
    {
      label: 'Không đồng ý',
      value:
        totalPeopleCountv2 === 0
          ? '0%'
          : `${((voteCounts.DISAGREE / totalPeopleCountv2) * 100).toFixed(2)}%`,
      percent:
        totalPeopleCountv2 === 0
          ? 0
          : (voteCounts.DISAGREE / totalPeopleCountv2) * 100,
      color: 'red',
    },
    {
      label: 'Không có ý kiến/ Ý kiến khác',
      value:
        totalPeopleCountv2 === 0
          ? '0%'
          : `${((voteCounts.OTHER / totalPeopleCountv2) * 100).toFixed(2)}%`,
      percent:
        totalPeopleCountv2 === 0
          ? 0
          : (voteCounts.OTHER / totalPeopleCountv2) * 100,
      color: 'green',
    },
  ]

  const formatDateTime = dateTimeString => {
    const date = new Date(dateTimeString)

    if (isNaN(date)) {
      return 'Invalid date'
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`
  }

  const toggleMenu = () => {
    // if (isMenuOpen) {
    //   setSelectedIndex(null)
    // }
    setIsMenuOpen(!isMenuOpen)
  }

  const handleItemClick = (index, fId) => {
    fetchDetailComment(fId)
    setSelectedIndex(fId)
    setIndexLmao(index)
  }

  function htmlToText(html) {
    const tempElement = document.createElement('div')
    tempElement.innerHTML = html
    return tempElement.textContent || tempElement.innerText || ''
  }

  useEffect(() => {
    if (feedbackDetailData?.feedbackComments?.length === 1) {
      handleItemClick(0, feedbackDetailData?.feedbackComments[0]?.id)
    }
  }, [feedbackDetailData])

  const handleOpenPopupSign = () => {
    // if (!fileActiveIsPDF) {
    //   return message.info('Bạn chỉ được phép ký số file PDF')
    // }
    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({
      name: latestFeedbacks?.fileName,
    })
    setIsVisiblePopupSign(true)
  }

  const feedbackWithCurrentUser = latestFeedbacks?.find(
    item => item?.feedbackUsername === currentUser?.username
  )

  const {
    fileId: fileIdWithCurrentUser,
    fileName: fileNameWithCurrentUser,
    detailFeedbackComment: commentWithCurrentUser,
    voteType: selectedOption,
    id: latestId,
  } = feedbackWithCurrentUser || {}

  const handleAfterSign = async fileSignId => {
    if (!fileSignId) return
    try {
      setIsVisiblePopupSign(false)
      const updateStatusData = {
        feedbackUsername: currentUser?.username,
        detailFeedbackComment: commentWithCurrentUser,
        voteType: selectedOption,
        fileId: fileSignId.fileSignUrl,
        fileName: fileSignId.fileOriginName,
      }
      await FeedbackCommentStore.updateVotingStatus(latestId, updateStatusData)
      await fetchDetailComment(feedbackCommentDataDetailV2.id)
    } catch (error) {
      message.error(error.message)
      // console.log(error)
    } finally {
      setIsVisiblePopupSign(false)
    }
  }

  const currentUserFeedbacks =
    feedbackCommentDataDetailV2?.feedbackCommentDetails?.filter(
      item => item.feedbackUsername === currentUser.username
    ) || []

  const sortedFeedbacks = currentUserFeedbacks.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  )

  const displayComment = sortedFeedbacks.reduce((result, feedback) => {
    if (result) return result
    if (
      feedback.detailFeedbackComment &&
      feedback.detailFeedbackComment !== ''
    ) {
      return feedback.detailFeedbackComment
    }
    return result
  }, '')

  return (
    <>
      <DashboardLayout>
        <Helmet>
          <title>Chi tiết Phiếu lấy ý kiến | {systemName} Portal</title>
        </Helmet>
        <PageTitle
          location={props.location}
          title={feedbackDetailData.title}
          showTitle={true}>
          <HeadingButtonWrapper>
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <span className={'btn-style'}>
                <MoreOutlined style={{ color: blue }} />
              </span>
            </Dropdown>
          </HeadingButtonWrapper>
        </PageTitle>
        <>
          <ViewDetailContent>
            <ContentWrapper>
              <BlockLeft>
                <ContentBlockWrapper style={{ marginBottom: 20 }}>
                  <TitleContentBox>Căn Cứ</TitleContentBox>
                  <div
                    style={{
                      maxWidth: '1200px',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: feedbackDetailData.legalBasis,
                    }}></div>
                </ContentBlockWrapper>
                <ContentBlockWrapper
                  style={{
                    marginBottom: 20,
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      fontWeight: 500,
                      fontSize: 14,
                      margin: '-16px -16px 10px -16px',
                      borderTopLeftRadius: 6,
                      borderTopRightRadius: 6,
                      padding: '10px 16px',
                      color: '#fff',
                      backgroundColor: blue,
                    }}
                    onClick={toggleMenu}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span>Nội dung ý kiến</span>
                      <p style={{ fontSize: 10, margin: 0 }}>
                        (Chọn ý kiến bên dưới để xem chi tiết)
                      </p>
                    </div>
                    <span>{isMenuOpen ? 'Ẩn ý kiến' : 'Hiển thị ý kiến'}</span>
                  </div>

                  <div
                    style={{
                      overflow: 'hidden',
                      maxHeight: isMenuOpen ? '300px' : '0',
                      opacity: isMenuOpen ? 1 : 0,
                      transition:
                        'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease',
                      backgroundColor: '#fff',
                    }}>
                    <Menu
                      mode="inline"
                      style={{
                        width: '100%',
                        border: 'none',
                        boxSizing: 'border-box',
                      }}>
                      {feedbackDetailData?.feedbackComments?.map(
                        (feedback, index) => (
                          <Menu.Item
                            key={index}
                            style={{
                              fontSize: '12px',
                              fontWeight: '500',
                              borderRadius: 6,
                              margin: indexLmao === index ? '5px' : 0,
                              backgroundColor:
                                indexLmao === index ? '#E6F4FF' : '#fff',
                              color: indexLmao === index ? '#1677FF' : '#000',
                              padding: '8px 12px',
                              height: 'auto',
                              lineHeight: 'normal',
                            }}
                            onClick={() => handleItemClick(index, feedback.id)}>
                            <Tooltip
                              title={htmlToText(feedback.content)}
                              placement="top"
                              overlayStyle={{
                                maxWidth: '300px',
                                whiteSpace: 'normal',
                              }}>
                              <div
                                style={{
                                  width: '100%',
                                  display: 'block',
                                  whiteSpace:
                                    indexLmao === index ? 'normal' : 'nowrap',
                                  textOverflow:
                                    indexLmao === index ? 'unset' : 'ellipsis',
                                  overflow: 'hidden',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word', // Handle long words
                                  maxHeight:
                                    indexLmao === index ? 'none' : '1.5em', // One line for non-selected
                                }}>
                                <span
                                  style={{
                                    marginRight: '10px',
                                    fontWeight: 700,
                                  }}>
                                  {index + 1}.
                                </span>
                                <span style={{ fontWeight: 700 }}>
                                  {htmlToText(feedback.content)}
                                </span>
                              </div>
                            </Tooltip>
                          </Menu.Item>
                        )
                      )}
                    </Menu>
                  </div>
                </ContentBlockWrapper>

                <ContentBlockWrapper
                  style={{
                    marginBottom: 20,
                  }}>
                  <TitleContentBox>Tài liệu kèm theo</TitleContentBox>
                  <div
                    style={{
                      maxWidth: '1200px',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: feedbackDetailData.attachedDocuments,
                    }}></div>
                </ContentBlockWrapper>
                <ContentBlockWrapper style={{ marginBottom: 20 }}>
                  <TitleContentBox>Nội dung khác</TitleContentBox>
                  <div
                    style={{
                      maxWidth: '1200px',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: feedbackDetailData.otherContent,
                    }}></div>
                </ContentBlockWrapper>
              </BlockLeft>
              <BlockRight>
                {!selectedIndex &&
                  feedbackDetailData?.feedbackComments?.map(
                    (feedback, index) => (
                      <ContentBlockWrapper
                        key={feedback.id}
                        style={{ marginBottom: 20 }}>
                        <TitleContentBox>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}>
                            <Tooltip
                              title={`Thống kê - ${htmlToText(
                                feedback.content
                              )}`}
                              placement="top"
                              overlayStyle={{
                                maxWidth: '300px',
                                whiteSpace: 'normal',
                              }}>
                              <span>
                                Thống kê -{' '}
                                {feedback.content
                                  .replace(/<[^>]+>/g, '')
                                  .substring(0, 50) +
                                  (feedback.content.replace(/<[^>]+>/g, '')
                                    .length > 50
                                    ? '...'
                                    : '')}
                              </span>
                            </Tooltip>
                          </div>
                        </TitleContentBox>
                        <List
                          itemLayout="horizontal"
                          dataSource={getDataForFeedback(feedback.id)}
                          renderItem={item => (
                            <List.Item>
                              <Row style={{ width: '100%' }}>
                                <Col span={12}>
                                  <span>{item.label}</span>
                                </Col>
                                <Col span={12} style={{ textAlign: 'right' }}>
                                  <span>{item.value}</span>
                                </Col>
                                <Col span={24}>
                                  <Progress
                                    percent={item.percent}
                                    strokeColor={item.color}
                                    status="active"
                                    showInfo={false}
                                  />
                                </Col>
                              </Row>
                            </List.Item>
                          )}
                        />
                      </ContentBlockWrapper>
                    )
                  )}
                {selectedIndex && idIncludes?.includes(selectedIndex) && (
                  <ContentBlockWrapper
                    key={selectedIndex}
                    style={{ marginBottom: 20 }}>
                    <TitleContentBox>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}>
                        <span>Thống kê</span>
                        <div style={{ gap: 10, display: 'flex' }}>
                          <Tag
                            onClick={() => {
                              setSelectedIndex(null)
                              setIndexLmao(null)
                            }}
                            style={{
                              borderRadius: 10,
                              cursor: 'pointer',
                              marginRight: 0,
                              width: 'auto',
                              textAlign: 'center',
                            }}
                            color={'blue'}>
                            Tổng hợp biểu quyết
                          </Tag>
                        </div>
                      </div>
                    </TitleContentBox>
                    <List
                      itemLayout="horizontal"
                      dataSource={getDataForFeedback(selectedIndex)}
                      renderItem={item => {
                        return (
                          <List.Item>
                            <Row style={{ width: '100%' }}>
                              <Col span={12}>
                                <span>{item.label}</span>
                              </Col>
                              <Col span={12} style={{ textAlign: 'right' }}>
                                <span>{item.countValue}</span>
                              </Col>
                              <Col span={24}>
                                <Progress
                                  percent={item.percent}
                                  strokeColor={item.color}
                                  status="active"
                                  showInfo={false}
                                  strokeWidth={10}
                                />
                              </Col>
                            </Row>
                          </List.Item>
                        )
                      }}
                    />
                  </ContentBlockWrapper>
                )}
                {idIncludes?.includes(selectedIndex) && (
                  <>
                    {userNameHaventVoting.includes(currentUser?.username) && (
                      <ContentBlockWrapper style={{ marginBottom: 20 }}>
                        <TitleContentBox>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}>
                            <span>Ý kiến bạn biểu quyết</span>
                            <div style={{ gap: 10, display: 'flex' }}>
                              <AccessControlAction
                                aclActionType={ACL_ACTION_TYPE.voting__HDQT}>
                                <Tag
                                  onClick={() => {
                                    setIsVisiblePopupBieuQuyet(true)
                                  }}
                                  style={{
                                    borderRadius: 10,
                                    cursor: 'pointer',
                                    marginRight: 0,
                                    width: '80px',
                                    textAlign: 'center',
                                  }}
                                  color={'blue'}>
                                  Biểu Quyết
                                </Tag>
                              </AccessControlAction>
                              <Tag
                                onClick={handleOpenPopupSign}
                                style={{
                                  borderRadius: 10,
                                  cursor: 'pointer',
                                  marginRight: 0,
                                  width: '80px',
                                  textAlign: 'center',
                                }}
                                color={'blue'}>
                                Ký số
                              </Tag>
                            </div>
                          </div>
                        </TitleContentBox>
                        <DocumentInfoList>
                          {latestFeedbacks?.filter(
                            item =>
                              item.feedbackUsername === currentUser.username
                          )[0]?.createdAt ? (
                            <>
                              <dt>Bạn Biểu quyết</dt>
                              <dd>
                                Ngày:{' '}
                                {formatDateTime(
                                  latestFeedbacks?.filter(
                                    item =>
                                      item.feedbackUsername ===
                                      currentUser.username
                                  )[0].createdAt
                                )}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Bạn Biểu quyết</dt>
                              <dd>Chưa có ngày biểu quyết</dd>
                            </>
                          )}
                          {latestFeedbacks?.filter(
                            item =>
                              item.feedbackUsername === currentUser.username
                          )[0]?.updatedAt ? (
                            <>
                              <dt>Thay đổi</dt>
                              <dd>
                                Ngày:{' '}
                                {formatDateTime(
                                  latestFeedbacks?.filter(
                                    item =>
                                      item.feedbackUsername ===
                                      currentUser.username
                                  )[0]?.updatedAt
                                )}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Thay đổi</dt>
                              <dd>Chưa có ngày thay đổi</dd>
                            </>
                          )}
                          {latestFeedbacks?.filter(
                            item =>
                              item.feedbackUsername === currentUser.username
                          )[0]?.voteType ? (
                            <>
                              <dt>Lựa chọn</dt>
                              <dd>
                                {latestFeedbacks?.filter(
                                  item =>
                                    item.feedbackUsername ===
                                    currentUser.username
                                )[0]?.voteType === 'AGREE'
                                  ? 'Đồng ý'
                                  : latestFeedbacks?.filter(
                                      item =>
                                        item.feedbackUsername ===
                                        currentUser.username
                                    )[0]?.voteType === 'DISAGREE'
                                  ? 'Không đồng ý'
                                  : 'Không có ý kiến/ Ý kiến khác'}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Lựa chọn</dt>
                              <dd>Chưa có lựa chọn</dd>
                            </>
                          )}
                          {displayComment ? (
                            <>
                              <dt>Các ý kiến bổ sung</dt>
                              <dd>
                                <div
                                  style={{
                                    maxWidth: '318px',
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word',
                                    wordBreak: 'keep-all',
                                    lineBreak: 'strict',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: displayComment,
                                  }}
                                />
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Các ý kiến bổ sung</dt>
                              <dd>Không có ý kiến</dd>
                            </>
                          )}
                        </DocumentInfoList>
                      </ContentBlockWrapper>
                    )}
                    {!userNameHaventVoting.includes(currentUser?.username) && (
                      <div
                        style={{
                          fontWeight: 500,
                          fontSize: '14px',
                          margin: '-16px -16 10px',
                          borderTopLeftRadius: 6,
                          borderTopRightRadius: 6,
                          padding: '10px 16px',
                          color: '#fff',
                          backgroundColor: blue,
                          marginBottom: 20,
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <span>Đăng ý kiến</span>
                          <Tag
                            onClick={() => {
                              setIsVisiblePopupBieuQuyet(true)
                            }}
                            style={{
                              borderRadius: 10,
                              cursor: 'pointer',
                              marginRight: 0,
                              width: '80px',
                              textAlign: 'center',
                            }}
                            color={'blue'}>
                            Đăng ý kiến
                          </Tag>
                        </div>
                      </div>
                    )}
                    <ContentBlockWrapper style={{ marginBottom: 20 }}>
                      <TitleContentBox>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <span>Ý kiến biểu quyết (Ký số)</span>
                        </div>
                      </TitleContentBox>
                      <DocumentInfoList>
                        {latestFeedbacks?.length > 0 ? (
                          latestFeedbacks.some(comment =>
                            userNameHaventVoting.includes(
                              comment.feedbackUsername
                            )
                          ) ? (
                            latestFeedbacks.map(comment =>
                              userNameHaventVoting.includes(
                                comment.feedbackUsername
                              ) ? (
                                <Fragment key={comment.fileId}>
                                  <dt>
                                    {getNameUppercaseByUsername(
                                      comment.feedbackUsername
                                    )}
                                  </dt>
                                  <dd>
                                    <FileItem
                                      key={comment.fileId}
                                      file_id={comment.fileId}
                                      file_name={comment.fileName}
                                      file_type={utils.getExtensionFile(
                                        comment.fileName
                                      )}
                                    />
                                  </dd>
                                </Fragment>
                              ) : null
                            )
                          ) : (
                            <Fragment key={new Date().getTime()}>
                              <dt>Biểu quyết</dt>
                              <dd>Chưa có biểu quyết</dd>
                            </Fragment>
                          )
                        ) : (
                          <Fragment key={new Date().getTime() + 1}>
                            <dt>Biểu quyết</dt>
                            <dd>Chưa có biểu quyết</dd>
                          </Fragment>
                        )}
                      </DocumentInfoList>
                    </ContentBlockWrapper>
                    <ContentBlockWrapper style={{ marginBottom: 20 }}>
                      <TitleContentBox>Tài liệu kèm theo</TitleContentBox>
                      <DocumentInfoList>
                        {allFileNames?.length > 0 ? (
                          <>
                            <dt>Tài liệu đính kèm</dt>
                            <dd>
                              {allFileNames?.flatMap(group =>
                                group.map(fileName => (
                                  <FileItem
                                    style={{ marginBottom: '8px' }}
                                    key={fileName.id}
                                    file_id={fileName.fileId}
                                    file_name={fileName.fileName}
                                    file_type={utils.getExtensionFile(
                                      fileName.fileName
                                    )}
                                  />
                                ))
                              )}
                            </dd>
                          </>
                        ) : (
                          <>
                            <dt>Tài liệu đính kèm</dt>
                            <dd>Chưa có tài liệu đính kèm</dd>
                          </>
                        )}
                      </DocumentInfoList>
                    </ContentBlockWrapper>
                    <ContentBlockWrapper>
                      <TitleContentBox>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <span>Xử lý phiếu</span>
                        </div>
                      </TitleContentBox>
                      <UserListWrapper>
                        <div style={{ display: 'flex', flexGrow: 1 }}>
                          <b style={{ marginRight: '35px' }}>Người xử lý:</b>
                          {handlerAssignList?.length !== 0 ? (
                            <PopoverWatchTime
                              departWithUsers={departmentWithUserListV2}
                              userList={selectUserStore.convertListToDefault(
                                handlerAssignList?.filter(user => {
                                  return (
                                    user.permission === ASSIGNEE_TYPE.HANDLER &&
                                    user.name_uppercase != null
                                  )
                                })
                              )}
                              title={'Người xử lý'}
                              isFullViewer={true}
                              compared_date={
                                VIEWLOG_DATE.internal_document_until
                              }
                              typeId={feedbackId}
                              created_at={feedbackDetailData.createdAt}
                            />
                          ) : (
                            <EmptyText>Không có Người xử lý.</EmptyText>
                          )}
                        </div>
                      </UserListWrapper>
                      <UserListWrapper>
                        <div style={{ display: 'flex', flexGrow: 1 }}>
                          <b
                            style={{
                              flex: 'none',
                              marginRight: '11px',
                              whiteSpace: 'pre-line',
                            }}>
                            Ý kiến của Ban Kiểm Soát
                            <br /> và Các Tiểu Ban:
                          </b>
                          {combinerAssignList?.length !== 0 ? (
                            <PopoverWatchTime
                              departWithUsers={departmentWithUserListV2}
                              userList={selectUserStore.convertListToDefault(
                                updatedData1
                              )}
                              title={'Danh sách Ý kiến của các tiểu ban'}
                              isFullViewer={true}
                              compared_date={
                                VIEWLOG_DATE.internal_document_until
                              }
                              typeId={feedbackId}
                              created_at={feedbackDetailData.createdAt}
                            />
                          ) : (
                            <EmptyText>
                              Không có Ý kiến của các tiểu ban.
                            </EmptyText>
                          )}
                        </div>
                      </UserListWrapper>
                    </ContentBlockWrapper>
                  </>
                )}
              </BlockRight>
            </ContentWrapper>
          </ViewDetailContent>
        </>
      </DashboardLayout>

      {isEditModalVisible && (
        <FeedbackBoardUpdate
          feedbackDetailData={feedbackDetailData}
          isVisible={isEditModalVisible}
          handleCancel={handleCloseEditModal}
          fetchFeedback={fetchFeedbackDetailData}
          setIsVisible={setIsEditModalVisible}
          finalUserList={userList}
          assignees={feedbackDetailData.assignees}
        />
      )}
      {isVisiblePopupBieuQuyet && (
        <FeedbackVotingPopup
          visible={isVisiblePopupBieuQuyet}
          onClose={handleClosePopup}
          feedbackDetailData={feedbackDetailData}
          fetchFeedbackDetailData={fetchFeedbackDetailData}
          fetchDetailComment={fetchDetailComment}
          selectedIndex={selectedIndex}
          userList={userList}
          userNameHaventVoting={userNameHaventVoting}
        />
      )}
      {exportDocx && (
        <ExportDocx
          countAllUser={countAllUser}
          countAgree={countAgree}
          countDisAgree={countDisAgree}
          countOther={countOther}
          totalPeopleCount={totalPeopleCountv2}
          feedbackDetailData={feedbackDetailData}
          finalUserList={userList}
          resultsVoting={results}
        />
      )}

      {isVisiblePopupSign && (
        <FeedbackSign
          isVisiblePopupSign={isVisiblePopupSign}
          handleClosePopupSign={() => {
            setIsVisiblePopupSign(false)
          }}
          hiddenSelectDocument
          fileId={fileIdWithCurrentUser}
          fileName={fileNameWithCurrentUser}
          handleAfterSign={handleAfterSign}
        />
      )}
      <div style={{ display: 'none' }}>
        <ExportPdf feedbackDetailData={feedbackDetailData} />
      </div>
    </>
  )
}

export default inject(
  'selectUserStore',
  'documentAccessibilityStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'FeedbackProcedureStore',
  'FeedbackCommentStore',
  'departmentStore',
  'userStore',
  'selectUserStore',
  'electronicDocumentStore',
  'signedDocumentStore',
  'fileStore',
  'userGroupStore'
)(observer(FeedbackBoardDetail))
